module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/facebook-77cf32bbf18a35107107cdf692e38362.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/facebook.svg
// module id = XEXJ
// module chunks = 24